module.exports = __webpack_public_path__ + "img/store-header-empty.8110223c.png";